import React from 'react';

const LocationPinIcon = () => (
  <svg className="icon icon-locationpin" width="12px" height="16px" viewBox="0 0 12 16">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-311.000000, -600.000000)" fill="#0C4287">
        <g transform="translate(288.000000, 580.000000)">
          <g id="Icons/grey/I/Info" transform="translate(23.000000, 20.000000)">
            <path
              d="M5.6,0 C2.504,0 0,2.504 0,5.6 C0,9.8 5.6,16 5.6,16 C5.6,16 11.2,9.8 11.2,5.6 C11.2,2.504 8.696,0 5.6,0 L5.6,0 Z M5.6,7.6 C4.496,7.6 3.6,6.704 3.6,5.6 C3.6,4.496 4.496,3.6 5.6,3.6 C6.704,3.6 7.6,4.496 7.6,5.6 C7.6,6.704 6.704,7.6 5.6,7.6 L5.6,7.6 Z"
              id="Shape"
              className="st0"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default LocationPinIcon;
